import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { DiagtoolRoutingModule } from './diagtool-routing.module';
import { DiagtoolOverviewComponent } from './components/diagtool-overview/diagtool-overview.component';
import { UIRouterModule } from '@uirouter/angular';
import { DIAGTOOL_STATES } from './diagtool.states';
import {SafeHtmlPipe} from './pipes/safehtml.pipe';

@NgModule({
  declarations: [ DiagtoolOverviewComponent, SafeHtmlPipe],
  imports: [
    SharedModule,
    DiagtoolRoutingModule,
    UIRouterModule.forChild({ states: [...DIAGTOOL_STATES]  })
  ]
})
export class DiagtoolModule { }
